
import { Vue, Component } from 'vue-property-decorator';
import AnimatedSection from '@/components/games/AnimatedSection.vue';
import IndentedContainer from '@/components/games/IndentedContainer.vue';
import HeaderBlock from '@/components/games/HeaderBlock.vue';

import Austin from '@/assets/images/index/austin.webp';
import Cat from '@/assets/images/index/cat.webp';
import Gradient from '@/assets/images/index/gradient.webp';
import House from '@/assets/images/index/house.webp';
import MM from '@/assets/images/index/mm.webp';
import Panda from '@/assets/images/index/panda.webp';
import Rix from '@/assets/images/index/rix.webp';

@Component({
  components: { HeaderBlock, IndentedContainer, AnimatedSection },
  data() {
    return {
      images: [
        { name: 'mm', src: MM },
        { name: 'house', src: House },
        { name: 'gradient', src: Gradient },
        { name: 'austin', src: Austin },
        { name: 'cat', src: Cat },
        { name: 'rix', src: Rix },
        { name: 'panda', src: Panda },
      ],
    };
  },
})
export default class GamesHeader extends Vue {
  handleResize() {
    const container = document.getElementById('images');
    if (!container) {
      return;
    }
    const height = container.offsetWidth * 0.382;
    container.style.height = `${height}px`;
  }

  handleScroll() {
    return false;
  }

  mounted() {
    window.addEventListener('resize', this.handleResize);

    this.handleResize();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
